module.exports = {
  SEM_PDP_REWRITE_HEADER: 'x-rewrite-sem-pdp',
  LD_SERVER_ANONYMOUS_ID_HEADER: 'x-server-anonymous-id',
  RANDOM_ANONYMOUS_ID_HEADER: 'x-random-anonymous-id',
};
